export default __webpack_public_path__ + "static/media/@vilumahome.26bdd313.jpg";